import * as types from '../actions/actionTypes';
import { registerKey } from '../lessonRegisterReadModel';

export default function lessonRegisterReadsReducer(state = {}, action) {
  if (action.type === types.LOAD_LESSON_REGISTER_SUCCESS) return {};
  if (action.type === types.LOAD_LESSON_REGISTER_SLICE_SUCCESS) {
    return { ...state, [action.readKey]: action.loadedAt };
  }
  if ([types.CREATE_LESSON_REGISTER_SUCCESS, types.UPDATE_LESSON_REGISTER_SUCCESS, types.DELETE_LESSON_REGISTER_OPTIMISTIC].includes(action.type)) {
    return { ...state, writes: { ...state.writes, [registerKey(action.lessonRegister)]: Date.now() } };
  }
  return state;
}
